export default {
    methods: {
        getError(field) {

            return this.block?.errors?.[field];
        },
    }
}